import type { ReactNode } from "react";
import { ChevronDown } from "lucide-react";

export function Section({
  title,
  kicker,
  children,
  defaultOpen = false
}: {
  title: string;
  kicker?: string;
  children: ReactNode;
  defaultOpen?: boolean;
}) {
  return (
    <details className="control-section" open={defaultOpen}>
      <summary>
        <span>
          <strong>{title}</strong>
          {kicker ? <small>{kicker}</small> : null}
        </span>
        <ChevronDown size={16} aria-hidden="true" />
      </summary>
      <div className="section-body">{children}</div>
    </details>
  );
}

export function RangeControl({
  label,
  value,
  min,
  max,
  step,
  onChange,
  format = (number) => `${Math.round(number * 100)}%`
}: {
  label: string;
  value: number;
  min: number;
  max: number;
  step: number;
  onChange: (value: number) => void;
  format?: (value: number) => string;
}) {
  return (
    <label className="range-row">
      <span>
        {label}
        <output>{format(value)}</output>
      </span>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(event) => onChange(Number(event.target.value))}
      />
    </label>
  );
}

export function Field({
  label,
  value,
  onChange,
  multiline = false,
  maxLength
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  multiline?: boolean;
  maxLength: number;
}) {
  const shared = {
    value,
    maxLength,
    onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      onChange(event.target.value)
  };
  return (
    <label className="field-row">
      <span>
        {label}
        <small>{value.length}/{maxLength}</small>
      </span>
      {multiline ? <textarea rows={3} {...shared} /> : <input type="text" {...shared} />}
    </label>
  );
}

